// extracted by mini-css-extract-plugin
module.exports = {"hidden":"Logo_hidden__syt6a","logo":"Logo_logo__5xyYV","isMobile":"Logo_isMobile__uNopP","image":"Logo_image__w0PMs"};